import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@amelio/ui-library';

import type { ReactNode } from 'react';

export interface InfoTooltipProps {
    message: string;
    dataTestId: string;
    children: ReactNode;
}

/**
 * Wraps a badge or a control so hovering it explains what it means — including a disabled button,
 * which swallows its own pointer events, hence the `span` the tooltip listens on.
 */
export const InfoTooltip = ({ message, dataTestId, children }: InfoTooltipProps) => (
    <TooltipProvider delayDuration={200}>
        <Tooltip>
            <TooltipTrigger asChild>
                <span data-testid={dataTestId}>{children}</span>
            </TooltipTrigger>

            <TooltipContent side={'top'}>{message}</TooltipContent>
        </Tooltip>
    </TooltipProvider>
);
